import React from 'react';

import { cn } from '../../utils';

interface SkipNavigationProps {
  links?: Array<{
    href: string;
    label: string;
  }>;
  className?: string;
}

const defaultLinks = [
  { href: '#main-content', label: 'Skip to main content' },
  { href: '#navigation', label: 'Skip to navigation' },
  { href: '#footer', label: 'Skip to footer' },
];

export const SkipNavigation: React.FC<SkipNavigationProps> = ({
  links = defaultLinks,
  className,
}) => {
  return (
    <nav
      className={cn(
        'sr-only focus-within:not-sr-only',
        'fixed top-0 left-0 z-50 w-full',
        'bg-white border-b border-gray-200 shadow-sm',
        className
      )}
      aria-label="Skip navigation"
    >
      <div className="container mx-auto px-4 py-2">
        <ul className="flex flex-wrap gap-4">
          {links.map((link, index) => (
            <li key={index}>
              <a
                href={link.href}
                className={cn(
                  'inline-flex items-center px-3 py-2 text-sm font-medium',
                  'text-blue-600 hover:text-blue-800',
                  'bg-blue-50 hover:bg-blue-100',
                  'border border-blue-200 rounded-md',
                  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
                  'transition-colors duration-200'
                )}
                onClick={e => {
                  e.preventDefault();
                  const target = document.querySelector(link.href);
                  if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                    // Focus the target element if it's focusable
                    if (target instanceof HTMLElement) {
                      target.focus();
                    }
                  }
                }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

// Screen reader only utility class for CSS
export const srOnlyStyles = `
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .focus-within\\:not-sr-only:focus-within {
    position: static;
    width: auto;
    height: auto;
    padding: inherit;
    margin: inherit;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
`;
